var __filename="/ui/form/index.js";var config = {
  ns: 'form'
, filename: __filename
, scripts: {
	field: require('./field')

	//TEMP
  //, test: require('./test')

  , text: require('./text')
  , textarea: require('./textarea')
  , button: require('./button')
  , 'buttons-row': require('./buttons-row')
  , email: require('./email')
  }
}

module.exports = function(app, options) {
  var outConfig = Object.create(config)
  outConfig.styles = options && options.styles;
  app.createLibrary(outConfig, options)
}